module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-1696251b59b3afb75a5b9135d1d98d91.svg";